import { useEffect, useState } from 'react';

const useSystemColorScheme = () => {
  // checks if window.matchMedia is function as a safeguard, as jest test doesn't have window.matchMedia
  const [isDark, setIsDark] = useState(
    () => typeof window.matchMedia === 'function' && window.matchMedia('(prefers-color-scheme: dark)').matches,
  );

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e: MediaQueryListEvent) => setIsDark(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isDark ? 'dark' : 'light';
};

export default useSystemColorScheme;
